import toastService from "utils/toast";
import { AssetCreateTypeEnum } from "./types";


export const getAssetCreateTypeFromMime = (
  mimeType: string,
  fileName?: string,
): AssetCreateTypeEnum => {
  const m = (mimeType || "").toLowerCase().trim();
  if (m.startsWith("image/")) return AssetCreateTypeEnum.IMAGE;
  if (m.startsWith("video/")) return AssetCreateTypeEnum.VIDEO;
  if (m.startsWith("audio/")) return AssetCreateTypeEnum.AUDIO;
  if (m === "application/pdf") return AssetCreateTypeEnum.PDF;
  if (m.startsWith("text/")) return AssetCreateTypeEnum.TEXT;

  const ext = fileName?.split(".").pop()?.toLowerCase();
  if (ext === "pdf") return AssetCreateTypeEnum.PDF;
  if (
    ext &&
    ["png", "jpg", "jpeg", "gif", "webp", "svg", "bmp", "ico", "heic"].includes(
      ext,
    )
  ) {
    return AssetCreateTypeEnum.IMAGE;
  }
  if (ext && ["mp4", "webm", "mov", "avi", "mkv", "m4v"].includes(ext)) {
    return AssetCreateTypeEnum.VIDEO;
  }
  if (
    ext &&
    ["mp3", "wav", "aac", "m4a", "flac", "opus", "weba", "oga"].includes(ext)
  ) {
    return AssetCreateTypeEnum.AUDIO;
  }

  return AssetCreateTypeEnum.TEXT;
};

export const mediaValidator = ({ file, meta, type, mediaType }) => {
    if (mediaType === "image") {
        if(!file.type.includes("image")) {
            toastService.error("Only images are allowed")
            return;
        }
        if (type === "background" && meta?.width && meta?.height) {
            if(meta.width !== 390 || meta.height !== 600) {
                toastService.error("Background image should be of dimension 390x600")
                return;
            }
            return;
        }
        if(meta.width !== 390 || meta.height !== 95) {
            toastService.error("Banner image should be of dimension 390x95")
            return;
        }
    }
    if (mediaType === "video") {
        if(!file.type.includes("video")) {
            toastService.error("Only videos are allowed")
            return;
        }
    }
}